import {EntityData, field, identifier, transientField} from "@fedeltapointofsale/data-client";

export class TerminalReferenceData extends EntityData<TerminalReferenceData> {
    @identifier terminalId: number;
    @field name: string;
}

export class TypedTerminalReferenceData extends EntityData<TerminalReferenceData> {
    @identifier terminalId: number;
    @field name: string;
    @field type: string;
    @transientField webTerminalId: number;
}

